import { useMemo } from 'react';
import Button from 'react-bootstrap/Button';
import { Link, useSearchParams } from 'react-router-dom';

import classNames from 'classnames';

import {
  BootstrapGenericTable,
  renderFormikFilterHeader,
} from '@components/Table/Table';

const renderActionCell = ({ value, plan, row }) => {
  const stockURL = `/order/numbers/plans/${plan.id}/type/${plan.type}/prefixes/${value}`;
  const backorderURL = `/order/numbers/backorders/plans/${plan.id}/type/${plan.type}/prefixes/${value}`;
  const { isBackorder } = row.original;
  return (
    <Button
      as={Link}
      variant="didxl"
      size="sm"
      to={isBackorder ? backorderURL : stockURL}
    >
      Select
    </Button>
  );
};

export const PlanPrefixTable = ({ useData, useDataArgs, plan }) => {
  const [searchParams] = useSearchParams();
  const prefix = searchParams.get('prefix') || '';
  const prefixName = searchParams.get('prefixName') || '';
  const filterData = { prefix, prefixName };
  const columns = useMemo(
    () => [
      {
        Header: () => renderFormikFilterHeader({ fieldName: 'prefix' }),
        accessor: 'prefix',
        className: 'col-md-3',
      },
      {
        Header: () =>
          renderFormikFilterHeader({ fieldName: 'prefixName', header: 'name' }),
        accessor: 'name',
        className: 'col-md-6',
      },
      {
        Header: 'Stock',
        accessor: 'stock',
        className: 'col-md-2',
      },
      {
        Header: 'Action',
        accessor: 'id',
        className: 'col-md-1',
        Cell: ({ value, row }) => renderActionCell({ value, plan, row }),
      },
    ],
    [plan]
  );
  return (
    <BootstrapGenericTable
      columns={columns}
      useData={useData}
      useDataArgs={useDataArgs}
      filterData={filterData}
      rowProps={({ original }) =>
        original.isBackorder
          ? { className: classNames('text-muted', 'bg-light') }
          : {}
      }
      tableProps={() => ({
        responsive: true,
        bordered: true,
        className: 'normalFontSize',
      })}
    />
  );
};
